import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="custom-fields"
export default class extends Controller {
  static targets = ["labelSelect", "fieldsContainer"]
  static values = { saved: { type: Object, default: {} } }

  connect() {
    this.renderFields()
  }

  labelChanged() {
    this.renderFields()
  }

  renderFields() {
    const labelId = this.labelSelectTarget.value
    const container = this.fieldsContainerTarget

    if (!labelId) {
      container.innerHTML = ""
      return
    }

    fetch(`/custom_field_definitions/search?label_id=${labelId}`, {
      headers: { "Accept": "application/json" }
    })
    .then(response => response.json())
    .then(fields => {
      if (fields.length === 0) {
        container.innerHTML = ""
        return
      }

      let html = '<div class="custom-fields-section"><div class="custom-fields-header">Additional Information</div>'

      const saved = this.savedValue || {}

      fields.forEach(field => {
        const required = field.required ? '<span class="text-danger">*</span>' : ''
        const requiredAttr = field.required ? 'required' : ''
        const savedVal = saved[field.name] || ''

        html += '<div class="custom-field-row">'
        html += `<label class="custom-field-label">${field.name} ${required}</label>`

        switch (field.field_type) {
          case 'text':
            html += `<input type="text" name="custom_fields[${field.name}]" class="form-control form-control-sm" value="${savedVal}" ${requiredAttr}>`
            break
          case 'number':
            html += `<input type="number" name="custom_fields[${field.name}]" class="form-control form-control-sm" value="${savedVal}" ${requiredAttr}>`
            break
          case 'dropdown':
            html += `<select name="custom_fields[${field.name}]" class="form-select form-select-sm" ${requiredAttr}>`
            html += '<option value="">Select...</option>'
            field.options.forEach(opt => {
              const selected = savedVal === opt ? ' selected' : ''
              html += `<option value="${opt}"${selected}>${opt}</option>`
            })
            html += '</select>'
            break
          case 'checkbox':
            const checked = savedVal === 'true' ? ' checked' : ''
            html += `<div class="form-check">`
            html += `<input type="hidden" name="custom_fields[${field.name}]" value="false">`
            html += `<input type="checkbox" name="custom_fields[${field.name}]" value="true" class="form-check-input"${checked}>`
            html += `<label class="form-check-label">Yes</label>`
            html += `</div>`
            break
        }

        html += '</div>'
      })

      html += '</div>'
      container.innerHTML = html
    })
    .catch(error => {
      console.error("Failed to load custom fields:", error)
      container.innerHTML = ""
    })
  }
}
